"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
var Weight = /** @class */ (function (_super) {
    __extends(Weight, _super);
    function Weight(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = {
            value: "",
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var number = _this.props.number;
            state = form_store_1.default.getState();
            if (_this._isMounted) {
                _this.setState({
                    value: state.data["weight_".concat(number)] || "",
                    error: state.error["weight_".concat(number)] || []
                });
            }
        });
        return _this;
    }
    Weight.prototype.componentDidMount = function () {
        this._isMounted = true;
        var number = this.props.number;
        var state = form_store_1.default.getState();
        this.setState({
            value: state.data["weight_".concat(number)] || "",
            error: state.error["weight_".concat(number)] || []
        });
    };
    Weight.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Weight.prototype.render = function () {
        var number = this.props.number;
        var _a = this.state, value = _a.value, error = _a.error;
        var errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("div", { className: "input-set" },
                react_1.default.createElement("input", { className: "input-text input-set__s", type: "text", name: "weight_".concat(number), value: value, onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput }),
                react_1.default.createElement("span", { className: "input-set__unit" }, "g"))));
    };
    return Weight;
}(react_1.Component));
exports.default = Weight;
